export const flicketLogo = "/static/flicket.png";

export const DOT_SEPARATOR = "•";

export const LINK_EXTERNAL_FAQ_DOMAIN =
  "https://flicketltd.zendesk.com/hc/en-us";

export const LINK_EXTERNAL_FAQ_TRANSFERRING_TICKETS = `${LINK_EXTERNAL_FAQ_DOMAIN}/categories/13255290653199-Reselling-Transferring-Tickets`;

// Shorter dash
export const EN_DASH = "–";
